import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Services from '../components/Services';
import Products from '../components/Products';
import Technologies from '../components/Technologies';
import Team from '../components/Team';
// import Testimonials from '../components/Testimonials';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <Hero />
      <Services />
      <Products />
      {/* <Technologies /> */}
      <Team />
      {/* <Testimonials /> */}
      <Contact />
      <Footer />
    </div>
  );
};

export default Home;